<template lang="pug">
  article.text-15.lg-text-13.transition-opacity.duration-200(:key="product.handle", :class="{'opacity-50 pointer-events-none': querying}")
    carousel.mb-20(v-if="slides.length", :images="slides", style="padding-bottom:150%", :noCaptions="true", bg="bg-cover bg-center")
    header.flex
      .w-40(v-if="no") {{ no.toString().padStart(2, '0') }}
      .flex-1.text-left
        h6 {{ product.vendor }}
        h5 {{ product.title.replace(product.vendor, '') }}
        h6(v-if="color(variant)") {{ color(variant) }}
        h6(v-if="variant && !priceHidden") {{ price(variant.priceV2.amount) }}
    section.mt-24.children-mt-em.bulleted-lists.product__descrip(v-html="product.descriptionHtml")
    product-actions.mt-24.w-grid-20.-ml-20.px-15(:product="product", @variant="variant = $event", :active="variant", :finePrintVisible="false", @changeColor="switchProduct", @foundVariations="productVariations = $event", :initialProductVariations="productVariations", v-bind="$attrs", :detailsLink="detailsModal", @viewSizing="detailsVisible = true", :buttonsHidden="!purchasable")

    //- size guide modal
    transition(name="overlaymenu", @after-enter="lockScroll(true)", @before-leave="lockScroll(false)")
      product-size-guide-modal(v-if="detailsVisible", :product="product", @close="detailsVisible = false")
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ProductActions from './ProductActions'
import Carousel from '@/components/Carousel/Carousel'
// import get from 'lodash/get'
import { optimImgSize } from '@/utils'
import ProductSizeGuideModal from '@/components/Shop/ProductSizeGuideModal'
export default {
  name: 'ProductThumbFull',
  props: {
    doc: { type: Object, default: () => ({}) },
    no: { type: Number, default: 0 },
    purchasable: { type: Boolean, default: false },
    priceHidden: { type: Boolean, default: false },
    detailsModal: { type: Boolean, default: false }
  },
  data () {
    return {
      product: {},
      variant: null,
      productVariations: null,
      querying: false,
      detailsVisible: false
    }
  },
  computed: {
    ...mapGetters({ price: 'shop/price' }),
    slides () {
      const images = this.product.images && this.product.images.edges.map(edge => edge.node)
      return !images ? [] : images.map(img => ({ url: img.transformedSrc, alt: img.alt, width: 1 }))
    }
    // isEnquireOnly () {
    //   const meta = get(this.product, 'metafields.edges') || []
    //   return meta.find(meta => meta.key === 'enquiry_only')
    // }
  },
  methods: {
    ...mapMutations(['lockScroll']),
    color (vrnt) {
      const opt = vrnt && vrnt.selectedOptions.find(opt => ['color', 'colour'].includes(opt.name.toLowerCase()))
      return opt && opt.value
    },
    async switchProduct (hndl) {
      if (hndl === this.product.handle) return
      this.querying = true
      const w = this.$el.offsetWidth
      const prd = await this.$store.dispatch('shop/getProduct', { handle: hndl, imgMaxW: optimImgSize(w) }).catch(e => console.error(e))
      this.querying = false
      if (!prd) return
      this.product = prd
    }
  },
  created () {
    this.product = this.doc
  },
  components: { ProductActions, Carousel, ProductSizeGuideModal }
}
</script>

<style>
</style>
